import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useMemo } from 'react'

import { PageBackButton } from '@/components/common/PageBackButton'
import { ChangelogEntryCard } from '@/components/changelog/changelog-entry-card'
import { getAllEntries, loadEntries } from '@/lib/changelog/load-entries'
import { markEntriesSeen } from '@/lib/changelog/last-seen'
import { getVisibleEntries } from '@/lib/changelog/visible'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/whats-new')({
    component: WhatsNewPage,
})

function WhatsNewPage() {
    const { hasPermission, arePermissionsLoaded, serverFlagOn } = useAuth()
    const canSeeInternal = hasPermission('settings.manage')

    const { customer, internal } = useMemo(() => {
        const all = loadEntries()
        return {
            customer: getVisibleEntries(
                all,
                hasPermission,
                arePermissionsLoaded,
                serverFlagOn,
            ),
            internal: canSeeInternal
                ? getAllEntries(all).filter((e) => e.audience === 'internal')
                : [],
        }
    }, [canSeeInternal, hasPermission, arePermissionsLoaded, serverFlagOn])

    // Xem trang = đã xem những entry ĐANG hiển thị. Phải chạy sau khi quyền nạp
    // xong (không phải trong loader như trước): lúc loader chạy chưa biết tài
    // khoản có quyền gì, đánh dấu sớm sẽ nuốt mất thông báo của entry gắn quyền.
    useEffect(() => {
        if (!arePermissionsLoaded) return
        markEntriesSeen(customer)
    }, [customer, arePermissionsLoaded])

    const isEmpty = customer.length === 0 && internal.length === 0

    return (
        <div className="mx-auto max-w-2xl space-y-6 page-pad">
            <div className="flex min-w-0 items-start gap-2">
                <PageBackButton className="-my-2 md:-my-1" />
                <header>
                    <h1 className="text-xl font-semibold">
                        {m.whats_new_title()}
                    </h1>
                    <p className="text-sm text-muted-foreground">
                        {m.whats_new_subtitle()}
                    </p>
                </header>
            </div>

            {isEmpty ? (
                <p className="text-sm text-muted-foreground">
                    {m.whats_new_empty()}
                </p>
            ) : (
                <div className="space-y-3">
                    {customer.map((entry) => (
                        <ChangelogEntryCard key={entry.id} entry={entry} />
                    ))}
                </div>
            )}

            {internal.length > 0 && (
                <section className="space-y-3">
                    <h2 className="text-sm font-semibold text-muted-foreground">
                        {m.whats_new_internal_section()}
                    </h2>
                    {internal.map((entry) => (
                        <ChangelogEntryCard key={entry.id} entry={entry} />
                    ))}
                </section>
            )}
        </div>
    )
}
